/**
 * 자체 결제 draft 생성(`/api/order/checkout`)의 **성공 응답 형태** — #6125.
 *
 * 예전엔 성공하면 결제 페이지로 307 을 돌려줬다. 클라이언트가 fetch 로
 * 부르고 리다이렉트를 따라가게(follow) 둬서 브라우저가 결제 페이지에 **POST 를 한 번 더** 보내 SSR 전체를 돌리고 HTML 을 버렸다
 * (2026-10-29 staging 실측 약 3.1s — 쓰는 건 `response.url` 하나였다).
 *
 * 그래서 클라이언트가 이 헤더를 실으면 서버는 `200 { redirectUrl }` 를 돌려준다.
 * 헤더로 고르는 이유는 **배포 스큐**다 — 이미 예전 JS 를 받은 사용자는 헤더를 안 싣고 307 을 기대한다.
 * 이 헤더가 없으면 서버는 계속 307 을 준다. 반대로 새 JS 가 예전 서버(롤백)를 만나면 307 이 오므로
 * 클라이언트도 `response.redirected` 를 계속 읽는다.
 */
export const CHECKOUT_RESPONSE_HEADER = "x-checkout-response";
export const CHECKOUT_RESPONSE_JSON = "json";
